import React, { useEffect } from 'react';
import { useLocation, useNavigate, Routes, Route } from 'react-router-dom';
import AdminLayout from './Admin/AdminLayout';
import Dashboard from './Admin/Dashboard';
import Users from './Admin/Users';
import Events from './Admin/Events';
import EventRegistrations from './Admin/EventRegistrations';
import AllEventRegistrations from './Admin/AllEventRegistrations';
import Banners from './Admin/Banners';
import SuccessStories from './Admin/SuccessStories';
import Members from './Admin/Members';
import Documents from './Admin/Documents';
import Certificates from './Admin/Certificates';
import { useAuth } from '../utils/AuthContext';

const AdminDashboard = () => {
  useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // If user navigates directly to /admin, redirect to /admin/dashboard
  useEffect(() => {
    if (location.pathname === '/admin') {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [location.pathname, navigate]);

  // Auth check is already done by AdminRoute, so we don't need it here

  // No need for additional authentication checks here since AdminRoute handles it
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id/registrations" element={<EventRegistrations />} />
        <Route path="/registrations" element={<AllEventRegistrations />} />
        <Route path="/banners" element={<Banners />} />
        <Route path="/stories" element={<SuccessStories />} />
        <Route path="/members" element={<Members />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="*" element={<Dashboard />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminDashboard;
